<template>
  <div class="ele-body">
    <el-card shadow="never">
      <ele-data-table ref="table" :config="table" :choose.sync="choose" highlight-current-row>
        <template>
          <el-table-column type="selection" width="45" align="center" />
          <el-table-column prop="branch_name" label="部系" show-overflow-tooltip width="250" align="center" />
          <el-table-column prop="grade_name" label="年级" show-overflow-tooltip width="250" align="center" />
          <el-table-column prop="class_name" label="班级" show-overflow-tooltip width="250" align="center" />
          <el-table-column prop="class_account" label="账号" show-overflow-tooltip width="250" align="center" />
          <el-table-column prop="class_password" label="密码" show-overflow-tooltip width="250" align="center" />
          <el-table-column label="操作" align="center" width="250">
            <template #default="{ row }">
              <el-link @click="editClassAccount(row)" icon="el-icon-edit" type="primary" :underline="false">编辑</el-link>
            </template>
          </el-table-column>
        </template>
      </ele-data-table>
    </el-card>
    <!-- 编辑弹窗 -->
    <el-dialog
      title="修改班级密码"
      :visible.sync="showEdit"
      width="400px"
      @closed="resetForm"
      :destroy-on-close="true"
      custom-class="ele-dialog-form"
      :lock-scroll="false"
    >
      <el-form :model="editForm" ref="editForm" :rules="editRules" label-width="100px">
        <el-form-item label="密码:" prop="classPassword">
          <el-input v-model="editForm.classPassword" placeholder="请输入密码" clearable />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="showEdit = false">取消</el-button>
        <el-button type="primary" @click="saveClassAccount()">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
  import { saveClassAccount } from '@/config/ipadComputer/tag';
  export default {
    name: 'department',
    data() {
      return {
        table: {
          // 表格配置
          url: '/classRoom/classAccountPage',
          method: 'GET',
          where: {},
          parseData(res) {
            if (res.resCode == 200) res.code = 0;
            res.count = res.data.total;
            res.data = res.data.records;
            return res;
          },
        },
        choose: [],
        editForm: {
          classPassword: '',
        },
        editRules: {
          classPassword: [{ required: true, message: '请输入密码', trigger: 'blur' }],
        },
        showEdit: false,
      };
    },
    methods: {
      // 打开添加部门弹窗
      addDepartment() {
        this.showEdit = true;
      },
      // 编辑部门
      editClassAccount(row) {
        this.editForm = Object.assign({}, row);
        this.showEdit = true;
      },
      // 保存或更新
      saveClassAccount() {
        this.$refs['editForm'].validate((valid) => {
          if (valid) {
            const loading = this.$loading({ lock: true });
            let formData = new FormData();
            for (let key in this.editForm) {
              if (this.editForm[key] !== null && this.editForm[key] !== undefined) {
                formData.append(key, this.editForm[key]);
              }
            }
            saveClassAccount(formData).then((res) => {
              loading.close();
              if (res.data.resCode == 200) {
                this.showEdit = false;
                this.$message({ type: 'success', message: res.data.resMsg });
                this.$refs.table.reload();
              } else {
                this.$message.error(res.data.resMsg);
              }
            });
          } else {
            return false;
          }
        });
      },
      // 重置表单
      resetForm() {
        this.editForm = {
          classPassword: '',
        };
        this.$refs['editForm'].resetFields();
      },
    },
  };
</script>

<style scoped lang="scss"></style>
